import { HttpClient } from '@adapters/HttpClient';
import { PendingOrder, PendingOrderFilters, PendingOrdersApiResponse } from '../models/PendingOrder';

export class PendingOrderApiAdapter {
    constructor(private httpClient: HttpClient) { }

    // 🎯 Obtener todos los pending orders
    async getPendingOrders(filters: PendingOrderFilters = {}): Promise<PendingOrder[]> {
        const response = await this.httpClient.get<PendingOrdersApiResponse>('/orders/products-to-prepare');
        return response;
    }
} 